/**
 * @generated SignedSource<<e8dca5785751aa5f70f854c54040a53f>>
 * @relayHash 3c50fcdcb26a2dd5e3d81a1c04369a89
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b99aeae9f0df6a7bca9414b7ce6f013700af4287f820cc74b0dfd95403d65cb2

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraRankMutationEdge = "BOTTOM" | "TOP" | "%future added value";
export type JiraRankMutationInput = {
  edge: JiraRankMutationEdge;
  issues: ReadonlyArray<string>;
  relativeToIssue: string;
};
export type useIssuesRankerMutation$variables = {
  rankInput: JiraRankMutationInput;
};
export type useIssuesRankerMutation$data = {
  readonly jira: {
    readonly rankIssues: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useIssuesRankerMutation = {
  response: useIssuesRankerMutation$data;
  variables: useIssuesRankerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rankInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "rankInput",
    "variableName": "rankInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIssuesRankerMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraRankMutationPayload",
            "kind": "LinkedField",
            "name": "rankIssues",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIssuesRankerMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraRankMutationPayload",
            "kind": "LinkedField",
            "name": "rankIssues",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b99aeae9f0df6a7bca9414b7ce6f013700af4287f820cc74b0dfd95403d65cb2",
    "metadata": {},
    "name": "useIssuesRankerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "824e5e71233747b29ef715625b9350f2";

export default node;
